<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="toggleMinimise()"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
@if (!minimise) {
<div class="modal-body">

  <!-- Key Info -->
  @if (codeCombination) {
<div class="key-info">
    <i class="fa fa-shield fa-lg"></i>
    Key: {{codeCombination.LEID}} - {{codeCombination.CDR_NO}} - {{codeCombination.REPORTING_PERIOD}} - {{codeCombination.ME_CODE}} - {{codeCombination.LEDGER}} - {{codeCombination.CURR}} - {{codeCombination.CHART_CODE}}
  </div>
}

  <!-- Loader -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  <!-- Form -->
  @if (showElimForm && !showFormLoader) {
<div>
    <form ngNoForm novalidate autocomplete="off">

      <!-- Home Office Details -->
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <label><strong>Home Office Details:</strong></label>
          <span><strong>{{homeOffice}}</strong></span>
        </div>
      </div>

      <!-- HO Currency Alert -->
      <div class="amount-alert">
        <strong>All amounts on this screen are in HO Currency.</strong>
      </div>

      <!-- Adjustment Notes -->
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <label>Adjustment Notes:</label>
          <input type="text"
                 class="form-control input-sm"
                 [(ngModel)]="ELIM_DESCRIPTION"
                 placeholder="Enter Elimination Description"
                 maxlength="250"
                 (keyup)="validateDesc()"
                 (blur)="removeMessage()">
          @if (formSubmitted && (!ELIM_DESCRIPTION || ELIM_DESCRIPTION.trim() === '')) {
<span class="form-error-container">
            Elimination Description is required.
          </span>
}
          @if (isMaxLimitReached) {
<span class="form-error-container">
            You have reached the maximum limit of characters allowed
          </span>
}
        </div>
      </div>

      <!-- Elim Type -->
      <div class="row">
        <hr>
        <div class="col-md-1"></div>
        <div class="col-md-11">
          <label class="radio-inline">Elim Type</label>
          <label class="radio-inline">
            <input type="radio"
                   name="rd_elim_type"
                   value="B"
                   [(ngModel)]="ELIM_TYPE"
                   [disabled]="isElimTypeDisabled"> Book
          </label>
          <label class="radio-inline">
            <input type="radio"
                   name="rd_elim_type"
                   value="T"
                   [(ngModel)]="ELIM_TYPE"
                   [disabled]="isElimTypeDisabled"> Tax
            @if (ELIM_TYPE === 'T') {
<span style="padding-left: 10px; color: red;">
              <strong>Are you sure you want to add Tax Eliminations?</strong>
            </span>
}
          </label>
        </div>
      </div>

      <!-- Accounts Table -->
      <div class="table-responsive">
        <hr>
        <table class="table table-hover table-bordered table-striped table-condensed">
          <thead>
            <tr>
              <th></th>
              <th class="text-center">Feed</th>
              <th class="text-center">Account</th>
              <th class="text-center">Trading Partner</th>
              <th class="text-center">Pre-Elim GAAP Amt</th>
              <th class="text-center">Other Elims Posted</th>
              <th class="text-center">This Elim</th>
              <th class="text-center">Post-Elim GAAP Amt:</th>
              <th class="text-center">Post-Elim E&amp;P</th>
            </tr>
          </thead>

          <tbody>
            @for (elimAccount of accounts; track $index; let i = $index) {
<tr>
              <!-- Remove button -->
              <td>
                @if (elimAccount.TYPE !== 'source') {
<i
                   (click)="removeAccount(i)"
                   class="fa fa-minus-circle color-red"
                   style="cursor: pointer;"
                   title="Remove This Account"></i>
}
              </td>

              <!-- Feed -->
              <td>
                @if (elimAccount.TYPE !== 'source') {
<select
                        gtwSearchableSelect
                        class="form-control input-sm"
                        [(ngModel)]="elimAccount.feedDtls"
                        [name]="'feed_' + i"
                        (change)="feedSelected(elimAccount.feedDtls, i)">
                  <option [ngValue]="null">Select Feed...</option>
                  @for (feed of feedDtls; track $index) {
<option [ngValue]="feed">
                    {{feed.LEID}} - {{feed.CDR_NO}} / {{feed.ME_CODE}} / {{feed.CURR}}
                  </option>
}
                </select>
}
                @if (elimAccount.TYPE === 'source') {
<span>
                  {{elimAccount.FEED_DISPLAY}}
                </span>
}
              </td>

              <!-- Account -->
              <td>
                @if (elimAccount.TYPE !== 'source') {

                  <div class="autocomplete-wrapper">
                    <input #acctInput
                           cdkOverlayOrigin
                           #acctOrigin="cdkOverlayOrigin"
                           type="text"
                           class="form-control input-sm"
                           [value]="elimAccount.acctSearchText || ''"
                           placeholder="begin typing to select a..."
                           (input)="searchAccounts($event, i)">
                    <i class="fa fa-search autocomplete-icon"></i>
                    <ng-template
                      cdkConnectedOverlay
                      [cdkConnectedOverlayOrigin]="acctOrigin"
                      [cdkConnectedOverlayOpen]="(acctSearchResults.length > 0 || loadingAccounts) && activeAcctSearchIndex === i"
                      [cdkConnectedOverlayWidth]="acctInput.offsetWidth"
                      [cdkConnectedOverlayPositions]="[
                        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
                        { originX: 'start', originY: 'top',    overlayX: 'start', overlayY: 'bottom' }
                      ]"
                      (overlayOutsideClick)="closeAcctOverlay()">
                      <div class="autocomplete-dropdown">
                        @if (acctSearchResults.length > 0) {

                          @for (acc of acctSearchResults; track $index) {
<div class="autocomplete-item"
                               (mousedown)="selectAccount(acc, i)">
                            {{acc.ACCT_DD_DISPLAY || (acc.LOCAL_ACCT + ' - ' + acc.LOCAL_ACCT_DESC)}}
                          </div>
}
                        
}
                        @if (loadingAccounts) {
<div class="autocomplete-item">
                          <i class="fa fa-spinner fa-spin"></i> Loading...
                        </div>
}
                      </div>
                    </ng-template>
                  </div>
                
}
                @if (elimAccount.TYPE === 'source') {
<span>
                  {{elimAccount.LOCAL_ACCT}} - {{elimAccount.LOCAL_ACCT_DESC}}
                </span>
}
              </td>

              <!-- Trading Partner -->
              <td>
                @if (elimAccount.TYPE === 'source') {
<span>
                  {{elimAccount.TP_ENTITY}}
                </span>
}
                @if (elimAccount.TYPE !== 'source') {

                  <div class="autocomplete-wrapper">
                    <input #tpInput
                           cdkOverlayOrigin
                           #tpOrigin="cdkOverlayOrigin"
                           type="text"
                           class="form-control input-sm"
                           [value]="elimAccount.tpSearchText || ''"
                           placeholder="begin typing to select t..."
                           (input)="searchTradingPartners($event, i)">
                    <i class="fa fa-search autocomplete-icon"></i>
                    <ng-template
                      cdkConnectedOverlay
                      [cdkConnectedOverlayOrigin]="tpOrigin"
                      [cdkConnectedOverlayOpen]="(tpSearchResults.length > 0 || loadingTPs) && activeTpSearchIndex === i"
                      [cdkConnectedOverlayWidth]="tpInput.offsetWidth"
                      [cdkConnectedOverlayPositions]="[
                        { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
                        { originX: 'start', originY: 'top',    overlayX: 'start', overlayY: 'bottom' }
                      ]"
                      (overlayOutsideClick)="closeTpOverlay()">
                      <div class="autocomplete-dropdown">
                        @if (tpSearchResults.length > 0) {

                          @for (tp of tpSearchResults; track $index) {
<div class="autocomplete-item"
                               (mousedown)="selectTradingPartner(tp, i)">
                            {{tp.TP_ENTITY}}
                          </div>
}
                        
}
                        @if (loadingTPs) {
<div class="autocomplete-item">
                          <i class="fa fa-spinner fa-spin"></i> Loading...
                        </div>
}
                      </div>
                    </ng-template>
                  </div>
                
}
              </td>

              <!-- Pre-Elim GAAP Amt -->
              <td class="text-right">
                @if (!elimAccount.PREELIMGAAPLOADING) {
<span>{{formatNumber(elimAccount.PRE_ELIM_GAAP_AMT_HO_CURR)}}</span>
}
                @if (elimAccount.PREELIMGAAPLOADING) {
<i class="fa fa-spinner fa-pulse"></i>
}
              </td>

              <!-- Other Elims Posted -->
              <td class="text-right">
                @if (!elimAccount.OTHERELIMSLOADING) {
<span>{{formatNumber(elimAccount.OTHER_ELIMS_AMT)}}</span>
}
                @if (elimAccount.OTHERELIMSLOADING) {
<i class="fa fa-spinner fa-pulse"></i>
}
              </td>

              <!-- This Elim -->
              <td>
                <input type="number"
                       class="form-control input-sm text-right"
                       [name]="'cur_elim_amt_' + i"
                       [(ngModel)]="elimAccount.CUR_ELIM_AMT"
                       (change)="setPostElimTotal(i)">
              </td>

              <!-- Post-Elim GAAP Amt -->
              <td class="text-right">
                @if (!elimAccount.POSTGAAPLOADING) {
<span>{{formatNumber(elimAccount.POST_ELIM_GAAP_AMT_HO_CURR)}}</span>
}
                @if (elimAccount.POSTGAAPLOADING) {
<i class="fa fa-spinner fa-pulse"></i>
}
              </td>

              <!-- Post-Elim E&P -->
              <td class="text-right">
                @if (!elimAccount.POSTEPLOADING) {
<span>{{formatNumber(elimAccount.POST_ELIM_EP_AMT_HO_CURR)}}</span>
}
                @if (elimAccount.POSTEPLOADING) {
<i class="fa fa-spinner fa-pulse"></i>
}
              </td>
            </tr>
}
          </tbody>

          <tfoot>
            <tr>
              <td>
                <i (click)="addTargetAccount()"
                   class="fa fa-plus-circle color-green"
                   style="cursor: pointer; font-size: 18px;"
                   title="Add new Account"></i>
              </td>
              <td class="text-center">Total</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-center">
                <input readonly type="text"
                       class="form-control input-sm text-right"
                       [ngClass]="{'color-background-red-light': elimReclassTotal !== 0}"
                       [value]="elimReclassTotal">
                @if (elimReclassTotal !== 0) {
<div class="form-error-container text-nowrap">
                  *Elimination must net to 0
                </div>
}
              </td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>

    </form>
  </div>
}
</div>
}

<!-- Modal Footer -->
@if (!minimise) {
<div class="modal-footer">
  <button class="btn btn-info"
          type="button"
          [disabled]="crudLoading"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    Save Reclass
  </button>
  <button class="btn btn-danger-outline"
          type="button"
          (click)="reset()">Reset Form</button>
  <button class="btn btn-warning"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
}

<!-- Existing Eliminations Table -->
@if (showElimForm && !minimise) {
<div style="margin-left: 30px; margin-right: 30px;">
  <div class="table-responsive">
    <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed">
      <thead>
        <tr>
          <th></th>
          <th style="text-align: center;">Edit</th>
          <th style="text-align: center;">Delete</th>
          <th>Adjustment Description</th>
          <th>Adjustment Type</th>
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Issue ID</th>
}
          @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<th>Scenario</th>
}
          <th>Last Updated</th>
          <th>Updated By</th>
        </tr>
      </thead>

      @if (existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" colspan="9">
            <i style="margin-top: 20px" class="fa fa-2x fa-spinner fa-pulse"></i>
          </td>
        </tr>
      </tbody>
}

      @if (noRecords && !existingLoading) {
<tbody>
        <tr>
          <td class="loading-table" colspan="9">
            <div style="margin-top: 40px"><b>No Existing Reclasses</b></div>
          </td>
        </tr>
      </tbody>
}

      @if (!existingLoading && !noRecords) {
<tbody>
        @for (reclass of reclassArray; track $index; let i = $index) {

          <tr>
            <td align="center">
              @if (!reclass.open) {
<i
                 (click)="showDetails(i, true)"
                 style="font-size: 20px; cursor: pointer;"
                 class="fa fa-plus-circle"></i>
}
              @if (reclass.open) {
<i
                 (click)="showDetails(i, false)"
                 style="font-size: 20px; cursor: pointer;"
                 class="fa fa-minus-circle"></i>
}
            </td>
            <td align="center">
              <a href="javascript:void(0)" (click)="loadReclass(i)">
                <i class="fa fa-pencil"></i> Edit
              </a>
            </td>
            <td align="center">
              <a href="javascript:void(0)" (click)="deleteReclass(reclass)">
                <i class="fa fa-times"></i>
              </a>
            </td>
            <td>{{reclass.ADJ_DESC}}</td>
            <td>{{reclass.ADJ_TYPE_DESC}}</td>
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{reclass.ISSUE_ID}}</td>
}
            @if (rowData.SCENARIO_TYPE_CODE === 'EXAM') {
<td>{{reclass.SCENARIO}}</td>
}
            <td>{{reclass.UPDATED_ON}}</td>
            <td>{{reclass.UPDATED_BY_NAME}}</td>
          </tr>

          <!-- Expanded Details -->
          @if (reclass.ACCOUNTS && reclass.open) {
<tr>
            <td colspan="9" style="background-color: #cdcdcd">
              <table class="table table-hover table-bordered table-striped table-condensed-xs">
                <thead>
                  <tr>
                    <th>Account Details</th>
                    <th>Feed</th>
                    <th>Trading Partner</th>
                    <th>Pre-Elim GAAP Amount</th>
                    <th>Adjustment Amount</th>
                  </tr>
                </thead>
                <tbody>
                  @for (account of reclass.ACCOUNTS; track $index) {
<tr>
                    <td>{{account.LOCAL_ACCT}} - {{account.LOCAL_ACCT_DESC}}</td>
                    <td>{{account.LEID}} - {{account.MARS}} / {{account.ME}} / {{account.FC}}</td>
                    <td>{{account.TP_ENTITY}}</td>
                    <td class="text-right">{{formatNumber(account.PRE_ELIM_GAAP_AMT)}}</td>
                    <td class="text-right" [ngClass]="{'color-red': account.CUR_ELIM_AMT < 0}">
                      {{formatNumber(account.CUR_ELIM_AMT)}}
                    </td>
                  </tr>
}
                </tbody>
              </table>
            </td>
          </tr>
}
        
}
      </tbody>
}
    </table>
  </div>
</div>
}
